export const ASSET_PACK_DOWNLOAD_JOB_TASK_ID = 'download-job-asset-pack';
export const FOLDER_ZIP_DOWNLOAD_JOB_TASK_ID = 'download-job-folder-zip';
export const EMPTY_FOLDER_DOWNLOAD_ERROR = 'DOWNLOAD_FOLDER_NO_FILES';

export type DownloadJobTaskPayload = {
  jobId: string;
  generation: number;
};

export type AssetPackDownloadItem = {
  itemId: string;
  assetId: string;
  assetGroup: string;
  assetType: 'image' | 'video' | '3d';
  ordinal: number;
  filenameHint?: string;
};

export type FolderZipDownloadItem = {
  itemId: string;
  path: string;
  relativePath: string;
  modifiedAt?: number;
  sizeBytes?: number;
};

export type DownloadJobTaskResult =
  | {
      status: 'completed';
      jobId: string;
      generation: number;
      counts: {
        total: number;
        packed: number;
        skipped: number;
        failed: number;
      };
      sizeBytes: number;
      storageKey: string;
    }
  | {
      status: 'stopped';
      reason: DownloadJobStopReason;
    };

export type DownloadJobStopReason = 'stale_generation';
